// =====================================================
// 📁 PendingQuotationsEmpty.tsx
// =====================================================

import { FileText } from 'lucide-react';

const PendingQuotationsEmpty = () => {
  return (
    <div
      className="
      flex
      flex-col
      items-center
      justify-center

      rounded-2xl

      border
      border-dashed
      border-stroke

      bg-whiten

      px-6
      py-14

      text-center

      dark:border-strokedark
      dark:bg-boxdark-2
    "
    >
      {/* ===================================================== */}
      {/* 🔹 Icon */}
      {/* ===================================================== */}

      <div
        className="
        flex
        h-18
        w-18
        items-center
        justify-center

        rounded-2xl

        border
        border-primary/10

        bg-primary/5

        text-primary
      "
      >
        <FileText size={30} />
      </div>

      {/* ===================================================== */}
      {/* 🔹 Content */}
      {/* ===================================================== */}

      <h3
        className="
        mt-5

        text-base
        font-semibold

        text-black

        dark:text-white
      "
      >
        No hay cotizaciones pendientes
      </h3>

      <p
        className="
        mt-2
        max-w-[280px]

        text-sm
        leading-relaxed

        text-body
      "
      >
        Las cotizaciones en borrador aparecerán aquí para que puedas
        continuarlas más tarde.
      </p>
    </div>
  );
};

export default PendingQuotationsEmpty;
